import type { ReactNode } from "react";
import "./ui.css";

interface SurfaceCardProps {
	children: ReactNode;
	onClick?: () => void;
	className?: string;
	isActive?: boolean;
}

/* Chose NOT to wrap MetricCard: MetricCard is an opinionated KPI tile
   (AntD Card + Statistic + trend), whereas SurfaceCard is a bare editorial
   surface (the .firm-stat-card / .firm-roster shell) meant to hold arbitrary
   content. Wrapping MetricCard would drag in its borderLeft/Statistic layout. */
export function SurfaceCard({
	children,
	onClick,
	className,
	isActive,
}: SurfaceCardProps) {
	const classes = [
		"ui-surface-card",
		onClick ? "is-clickable" : "",
		isActive ? "is-active" : "",
		className ?? "",
	]
		.filter(Boolean)
		.join(" ");

	if (onClick) {
		return (
			<button type="button" className={classes} onClick={onClick}>
				{children}
			</button>
		);
	}

	return <div className={classes}>{children}</div>;
}
